export default "__VITE_IMAGE_ASSET__2651c1e5__";